'use client';

export * from './_components/WebGtmNoScript';
export * from './_components/WebGlobalScript';
